import React, { useState, memo, useEffect } from 'react';
import './Styles.css';
import { mapCareOfFieldsForSelect } from './Functions';
import Select from '../../../../ids/InputElements/Select';
import TextInput from '../../../../ids/InputElements/TextInput';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../Enums/PresentationMode';

const CareOfFields = ({ modalMode, addressState, setAddressState }) => {
  const [isShown, setIsShown] = useState(
    !!addressState.address?.careOf?.prefix || !!addressState.address?.careOf?.name
  );

  useEffect(() => {
    setIsShown(!!addressState.address.careOf?.prefix || !!addressState.address.careOf?.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalMode]);

  const handleClick = () => {
    if (isShown) {
      const addressClone = { ...addressState.address };
      delete addressClone.careOf;
      setAddressState({
        ...addressState,
        address: addressClone,
      });
    }
    setIsShown(!isShown);
  };

  return (
    <>
      {modalMode === PresentationMode.Add || modalMode === PresentationMode.Edit ? (
        <p className="link-button" onClick={handleClick}>
          {formatMessage(isShown ? Messages.addressInfo_removeCo : Messages.addressInfo_addCo)}
        </p>
      ) : (
        <></>
      )}

      {isShown && (
        <div className="formatSwitcher-careOfFields-container">
          <div>
            <Select
              label={formatMessage(Messages.addressInfo_coType)}
              defaultValue={addressState.address?.careOf?.prefix ?? 0}
              onChange={event => {
                setAddressState({
                  ...addressState,
                  address: {
                    ...addressState.address,
                    careOf: {
                      ...addressState.address.careOf,
                      prefix: event.target.value,
                    },
                  },
                });
              }}
              options={mapCareOfFieldsForSelect()}
            />
          </div>

          <div>
            <TextInput
              label={formatMessage(Messages.addressInfo_coName)}
              onChange={event => {
                setAddressState({
                  ...addressState,
                  address: {
                    ...addressState.address,
                    careOf: {
                      ...addressState.address.careOf,
                      name: event.target.value,
                    },
                  },
                });
              }}
              value={addressState.address?.careOf?.name ?? ''}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(CareOfFields);
